import { Link } from 'gatsby'
import { format, parseISO } from 'date-fns'
import { Category, AuthorsItem } from '../types/blogPost'
import { buildImageObj } from './helpers'
import { imageUrlFor } from './image-url'
import { avatar } from './tags.module.css'

export function categoryTags(categories: Category[]) {
  const size = 4
  const categoriesSliced: Category[] = categories.slice(0, size)
  return (
    <div className="flex gap-4 text-sm">
      {categoriesSliced &&
        categoriesSliced.map((category) => (
          <Link
            key={category.id}
            to={
              category.slug
                ? `/blog/categories/${category.slug.current}/`
                : '/blog/archive/'
            }
            className="text-(--color-link)"
          >
            {category.name ? category.name : category.title}
          </Link>
        ))}
    </div>
  )
}

export function authorTags(authors: AuthorsItem[], publishedAt: string) {
  return authors.map((author) => (
    <div key={author.author.id} className="flex items-center gap-2">
      <div className={avatar}>
        {author.author.image && (
          <img
            src={imageUrlFor(buildImageObj(author.author.image))
              .width(100)
              .height(100)
              .fit('crop')
              .url()}
            alt={author.author.image.alt || 'Author image'}
            className="size-full"
          />
        )}
      </div>
      <p className="text-sm">
        {author.author.name} - {format(parseISO(publishedAt), 'LLLL d, yyyy')}
      </p>
    </div>
  ))
}
